import { createSystemLogsRoutes } from "@template/modules/systemLogsRoutes";

export const protectedRoutes = createSystemLogsRoutes({
  path: "logs",
  name: "system-logs",
  meta: {
    requiresAdmin: true,
    title: "logs.title",
    breadcrumb: ["settings.system", "logs.title"],
    requiresAuth: true,
  },
});
